"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AoIcon = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var DEFAULT_ELEMENT = 'span';
exports.AoIcon = react_1.default.forwardRef(function AOIcon(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.as, ElementType = _c === void 0 ? DEFAULT_ELEMENT : _c, icon = _a.icon, size = _a.size, labelProp = _a.label, props = __rest(_a, ["className", "as", "icon", "size", "label"]);
    var label = labelProp || props['aria-label'];
    var hasDescription = label || props['aria-labelledby'] || props['aria-describedby'];
    return (react_1.default.createElement(ElementType, __assign({ "data-aods": "icon" }, props, { className: (0, classnames_1.default)('ico', "ico-".concat(icon), (_b = {},
            _b["ico-".concat(size)] = size,
            _b), className), "aria-label": label, "aria-hidden": !hasDescription || undefined, ref: ref })));
});
exports.default = exports.AoIcon;
//# sourceMappingURL=Icon.js.map